import Vue from 'vue'
import App from './App.vue'
import Cookies from 'js-cookie'
import store from './store'
import router from './router'
import i18n from './i18n/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import 'animate.css';
import VueAppear from  './utils/vue-plugin'

Vue.use(VueDOMPurifyHTML);
Vue.use(VueAwesomeSwiper, /* { default global options } */);
//防止多次点击 v-preventReClick
import preventReClick from '@/utils/preventRepeatClick'  //防止重复点击 指令
Vue.use(ElementUI);
Vue.use(preventReClick);
Vue.use(VueAppear)
Vue.config.productionTip = false
Vue.prototype.$cookie = Cookies

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
